import * as React from 'react';
import './index.css';

interface IState {}

export default class LightSweep extends React.Component<any, IState> {
  state: IState = {};
  render() {
    return <view className="wm-light" />;
  }
}
